<template>
    <zen-slide-in
        :isOpen="isOpen"
        title="Create segment?"
        :error="error"
        @close="$emit('close')"
    >
        <div>
            <label
                for="segment-name"
                class="block text-sm lg:text-base font-medium text-taupe-800"
                >Search</label
            >
            <div class="mt-1">
                <input
                    type="text"
                    name="segment-name"
                    id="segment-name"
                    autocomplete="off"
                    :value="search"
                    @input="$emit('update:search', $event.target.value)"
                    class="block w-full rounded-md border-taupe-300 shadow-xs focus:border-taupe-500 focus:ring-taupe-500 sm:text-sm lg:text-base"
                />
            </div>
        </div>
        <zen-empty-table-message
            v-if="results.length == 0 && search === ''"
            compact
            icon="ZenIconFilter"
        >
            There are no available segments to associate with this context.
        </zen-empty-table-message>
        <zen-empty-table-message
            v-if="results.length == 0 && search !== ''"
            compact
            icon="ZenIconFilter"
        >
            There are no results for your search.
        </zen-empty-table-message>
        <div>
            <ul class="divide-y divide-taupe-100">
                <li
                    v-for="segment in results"
                    :key="segment.ulid"
                    class="flex gap-x-4 py-5"
                >
                    <zen-add-button
                        :label="segment.name"
                        :busy="isCreatingSegment(segment)"
                        :disabled="creating"
                        @click="$emit('add', segment)"
                    />
                    <div class="min-w-0 mt-3">
                        <p class="text-sm font-medium leading-6 text-taupe-800">
                            {{ segment.name }}
                        </p>
                    </div>
                </li>
            </ul>
        </div>
        <template v-slot:buttons>
            <zen-button variant="secondary" @click="$emit('close')">
                Done
            </zen-button>
        </template>
    </zen-slide-in>
</template>

<script>
export default {
    name: 'CreateContextSegmentSlideIn',
    props: {
        isOpen: {
            type: Boolean,
            required: true,
        },
        search: {
            type: String,
            default: '',
        },
        error: {
            type: [String, Object],
            default: null,
        },
        creating: {
            type: Boolean,
            default: false,
        },
        // ulid of the segment currently being added, so only that row shows
        // the spinner while every other add button is just disabled.
        creatingKey: {
            type: String,
            default: null,
        },
        results: {
            type: Array,
            required: true,
        },
    },
    emits: ['close', 'add', 'update:search'],
    methods: {
        isCreatingSegment(segment) {
            return this.creating && segment.ulid === this.creatingKey
        },
    },
}
</script>
